import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { token, layout } from "@universityofmaryland/web-styles-library";
function createLayoutStacked({
  isThemeDark = false,
  gap = token.spacing.md,
  spacing = token.spacing.md,
  showDividers = true,
  dividerColor
} = {}) {
  const defaultDividerColor = isThemeDark ? token.color.gray.dark : token.color.gray.light;
  const borderColor = dividerColor || defaultDividerColor;
  const dividerStyles = showDividers ? {
    [` > *:not(:last-child)`]: {
      paddingBottom: spacing,
      marginBottom: spacing,
      borderBottom: `1px solid ${borderColor}`
    }
  } : {};
  return new ElementBuilder().styled(layout.grid.stacked).withStyles({
    element: {
      gridGap: gap,
      ...dividerStyles
    }
  }).build();
}
export {
  createLayoutStacked
};
//# sourceMappingURL=stacked.js.map
